export const MyChallengesType = {
  LIVE: "Live",
  UPCOMING: "Upcoming",
  COMPLETED: "Completed",
};
